// src/pages/CashOutPage/CashOutPage.js
import React from 'react';
import './CashOutPage.css';
import CheckoutFormProduct from '../../components/CheckoutFormProduct/CheckoutFormProduct';
import CartSummary from '../../components/CartSummary/CartSummary';
import MiniProductsCarouselHome from '../../components/MiniProductsCarouselHome/MiniProductsCarouselHome';

const CashOutPage = () => {
  return (
    <div className="cashout-page-container">
      <h1 className="cashout-title">תשלום</h1>

      {/* עגלת קניות */}
      <div className="cart-summary-placeholder">
        <CartSummary / >
      </div>

      {/* טופס השארת פרטים */}
      <div className="customer-form-placeholder">
      <CheckoutFormProduct />
      </div>
          <div className='MoreProductSingaleProduct'>
      <h2 className='MoreProductH2SingaleProductPage'> מוצרים נוספים</h2>
      <MiniProductsCarouselHome />
</div>
    </div>
  );
};

export default CashOutPage;
